import { createReducer, on } from '@ngrx/store';

import * as actions from '../actions/aggregation.actions';
import { AggregationState } from '../states/aggregation.state';

export const AGGREGATION_REDUCER_KEY = 'aggregations';
const initialState: AggregationState = {
    aggregationsMap: {},
    reconAggregationsMap: {},
};

export const AGGREGATION_REDUCER = createReducer(
    initialState,
    on(actions.SetAggregationData, (state: AggregationState, { instanceId, parentRecordId, fieldId, aggregationResult }) => {
        return {
            ...state,
            aggregationsMap: {
                ...state.aggregationsMap,
                [instanceId]: {
                    ...state.aggregationsMap?.[instanceId],
                    [parentRecordId]: {
                        ...state.aggregationsMap?.[instanceId]?.[parentRecordId],
                        [fieldId]: {
                            ...state.aggregationsMap?.[instanceId]?.[parentRecordId]?.[fieldId],
                            aggregations: [
                                ...(state.aggregationsMap?.[instanceId]?.[parentRecordId]?.[fieldId]?.aggregations || []),
                                ...(Array.isArray(aggregationResult) ? aggregationResult : []),
                            ],
                        },
                    },
                },
            },
        };
    }),
    on(
        actions.SetReconCardinalityCount,
        (state: AggregationState, { instanceId, parentRecordId, fieldId, reconCardinalityCount: reconCardinalityCount }) => {
            return {
                ...state,
                reconAggregationsMap: {
                    ...state.reconAggregationsMap,
                    [instanceId]: {
                        ...state.reconAggregationsMap?.[instanceId],
                        [parentRecordId]: {
                            ...state.reconAggregationsMap?.[instanceId]?.[parentRecordId],
                            [fieldId]: {
                                ...state.reconAggregationsMap?.[instanceId]?.[parentRecordId]?.[fieldId],
                                cardinalityCount: reconCardinalityCount,
                            },
                        },
                    },
                },
            };
        }
    ),
    on(actions.ClearAggregationData, (state: AggregationState, { instanceId, parentRecordId }) => {
        return {
            ...state,
            aggregationsMap: {
                ...state.aggregationsMap,
                [instanceId]: {
                    ...state.aggregationsMap?.[instanceId],
                    [parentRecordId]: undefined,
                },
            },
        };
    })
);

